import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
import { Name } from "@peculiar/asn1-x509";
import { DomainName } from "./domain_name";
import { id_ntQWAC } from "./oids";
export const id_DomainNameOwner = `${id_ntQWAC}.3`;
let DomainNameOwner = class DomainNameOwner extends DomainName {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, Name.prototype);
    }
};
DomainNameOwner = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], DomainNameOwner);
export { DomainNameOwner };
